<template>
  <!-- 邮件管理Tab组件 -->
  <div class="emailManagementVO">
    <!-- 邮件列表 -->
    <el-row style="margin-bottom:20px;">
      <!-- 新增邮箱按钮 -->
      <el-button
        type="primary"
        class="mail-btn-primary addMailBoxBtn"
        @click="addUserDialogVisible = true"
      >{{ $t("poolOfMoney_page.addMailBox") }}
      </el-button>
    </el-row>

    <table class="emailManagement-table">
      <thead>
      <tr>
        <th style="width:104px;text-align:left;padding-left: 30px;box-sizing: border-box">
          {{ $t("financingFundList.indexTr") }}
        </th>
        <th style="width:277px">
          {{ $t("poolOfMoney_page.email") }}
        </th>
        <th style="width:374px">
          {{ $t("poolOfMoney_page.name") }}
        </th>
        <th style="width:217px">
          {{ $t("loan.remark") }}
        </th>
        <th style="width:228px">{{ $t("poolOfMoney_page.ope") }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in emailList.rows" :key="index">
        <td style="max-width:277px;text-align:left;padding-left: 30px;box-sizing: border-box">
          {{ index + 1 + (pg_st - 1) * 10 }}
        </td>
        <td style="max-width:240px">{{ item.mail }}</td>
        <td style="max-width:217px">{{ item.name }}</td>
        <td style="max-width:217px">{{ item.markes }}</td>
        <td>
          <span @click="showDelMoneyDialog(1,item.id)">{{ $t("poolOfMoney_page.delete") }}</span>
          <span v-if="item.useState == 1" @click="showDelMoneyDialog(2, item.id)">{{ $t("poolOfMoney_page.open") }}</span>
          <span v-if="item.useState == 0" @click="showDelMoneyDialog(3, item.id)">{{ $t("poolOfMoney_page.close") }}</span>
        </td>
      </tr>
      </tbody>
    </table>
    <!-- 当列表数据为空时显示界面 -->
    <div
      class="statusEmpty"
      v-if="!emailList.rows || !emailList.rows.length"
    >
      <i></i>{{ $t("frontPage.noData") }}
    </div>
    <!-- 翻页 -->
    <div class="emailManagement-pagination-box">
      <el-pagination
        style="text-align:center;"
        background
        layout="prev, pager, next"
        class="page-theme"
        :page-size="10"
        :total="total"
        :current-page.sync="pg_st"
        @current-change="getMailBoxList()"
        v-if="emailList.rows && emailList.rows.length"
      ></el-pagination>
    </div>
    <!-- 0=删除、1=启用、2=禁用的公用对话框 -->
    <el-dialog
      :title="delTitleText"
      :visible.sync="delUserDialogVisible"
      width="500px"
      class="delMoneyDlg"
    >
      <div style="width:500px;height:120px;padding-top:40px;">
        <p class="delUserDialogContent" style="color:#81899E">{{ delUserDialogContent }}</p>
      </div>
      <span class="addMailBoxSpan">
        <el-button
          class="mail-btn-primary"
          @click="delUser"
          style="margin:0 30px 0 55px;"
        >{{ $t("poolOfMoney_page.ok") }}</el-button
        >
        <el-button
          class="mail-btn-default"
          @click="delUserDialogVisible = false"
          style="margin:0;"
        >{{ $t("poolOfMoney_page.no") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增邮箱对话框 -->
    <el-dialog
      :title="this.$t('poolOfMoney_page.addMailBox')"
      :visible.sync="addUserDialogVisible"
      width="500px"
      @close="addUserDialogClosed"
      class="addMailBoxDlg"
    >
      <el-form
        :model="addUserForm"
        :rules="addUserFormRules"
        ref="addUserFormRef"
        label-width="78px"
      >
        <el-form-item
          :label="this.$t('poolOfMoney_page.email')"
          prop="mail"
          class="addMailInput"
          style="margin-bottom:20px; padding:0;"
        >
          <el-input
            :placeholder="this.$t('poolOfMoney_page.pleaseInput')"
            v-model.trim="addUserForm.mail"
            type="text"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="addMailInput"
          :label="this.$t('poolOfMoney_page.name')"
          prop="name"
          style="margin-bottom:20px; padding:0;"
        >
          <el-input
            :placeholder="this.$t('poolOfMoney_page.pleaseInput')"
            v-model.trim="addUserForm.name"
            type="text"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="addMailInput"
          :label="this.$t('loan.remark')"
          prop="markes"
          style="margin-bottom:10px; padding:0;"
        >
          <el-input
            :placeholder="this.$t('poolOfMoney_page.pleaseInput')"
            v-model.trim="addUserForm.markes"
            type="text"
            maxlength="50"
          ></el-input>
        </el-form-item>
      </el-form>
      <span class="addMailBoxSpan">
        <el-button
          class="mail-btn-primary"
          @click="addUser"
          style="margin:0 30px 0 55px;"
        >{{ $t("poolOfMoney_page.ok") }}</el-button
        >
        <el-button
          class="mail-btn-default"
          @click="addUserDialogVisible = false"
          style="margin:0;"
        >{{ $t("poolOfMoney_page.no") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "emailManagement",
  data(){
    // 验证邮箱的校验规则
    let checkUserEmail = (rule, value, cb) => {
      const regUserEmail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (!value) {
        return cb(new Error(this.$t("poolOfMoney_error.loan_account_4000007")));
      } else if (!regUserEmail.test(value)) {
        cb(new Error(this.$t("poolOfMoney_page.emailFormat")));
      } else {
        cb();
      }
    };

    // 验证姓名的校验规则
    let checkUserName = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t("poolOfMoney_page.noName")));
      } else if (value.length > 50) {
        cb(new Error(this.$t("poolOfMoney_page.nameLonger")));
      } else {
        cb();
      }
    };
    return {
      emailList:{
        rows: []
      },
      // 当前页码
      pg_st: 1,
      total: 0,
      delTitleText: "",
      delUserDialogContent: "",
      delUserDialogVisible: false,
      addUserDialogVisible: false,
      setRightDialogVisible: false,
      addUserForm: {
        name: "",
        mail: "",
        markes:"",
      },
      operationId:'',  //被操作邮箱的ID
      delNum: "",  // 操作类型：1删除，2启用，3禁用
      addUserFormRules: {
        mail: [{ validator: checkUserEmail, trigger: "click" }],
        name: [{ validator: checkUserName, trigger: "click" }],
      },
    };
  },
  created() {
    //获取邮件列表
    this.getMailBoxList()
  },
  methods:{
    getMailBoxList(){

      let params = {
        // page: this.pg_st,
        // rows: 10
      };
      this.axios.post("mail/findmail", params).then(res => {
        console.log(res);
        if (res.status) {
          this.emailList.rows = res.data;
          // this.total = res.data.total;
        } else {
          this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`));
          if (res.errorCode == "loan_audit_50000031") {
            setTimeout(function() {
              window.location.reload();
            }, 1500);
          }
        }
      });
    },
    //点击删除、启用、禁用按钮弹出对话框
    showDelMoneyDialog(code, mailID){
      this.operationId = mailID;
      if (code == 1){
        //删除
        this.delNum = 1;
        this.delTitleText = this.$t("poolOfMoney_page.delete");
        this.delUserDialogContent = this.$t("poolOfMoney_page.confirmDelete");
      } else if (code == 2){
        //启用
        this.delNum = 2;
        this.delTitleText = this.$t("poolOfMoney_page.open");
        this.delUserDialogContent = this.$t("poolOfMoney_page.openOk");
      } else if (code == 3){
        //禁用
        this.delNum = 3;
        this.delTitleText = this.$t("poolOfMoney_page.close");
        this.delUserDialogContent = this.$t("poolOfMoney_page.confirmClose");
      }
      this.delUserDialogVisible = true;
    },

    delUser(){
      let params = {};
      let _this = this;
      if (this.delNum == 1){
        console.log("删除邮箱");
        params = {
          id:this.operationId,
          isDelete:1
        }
        this.axios
          .post("mail/updatemail", params).then(res1 => {
            console.log(res1);
            if (res1.status) {
              console.log("删除邮箱成功");
              _this.$message.success(this.$t("poolOfMoney_page.opeOk"));
              _this.getMailBoxList();
            } else {
              _this.$message.error(
                _this.$t(`poolOfMoney_error.${res1.errorCode}`)
              );
              if (res1.errorCode == "loan_audit_50000031") {
                setTimeout(function() {
                  window.location.reload();
                }, 1500);
              }
            }
          });
      } else if (this.delNum == 2 || this.delNum == 3) {
        if (this.delNum == 2){
          params = {
            id:this.operationId,
            useState:0,
            isDelete:0,
          }
          console.log('启用邮箱')
        } else if (this.delNum == 3) {
          params = {
            id:this.operationId,
            useState:1,
            isDelete:0,
          }
          console.log('禁用邮箱')
        }
        this.axios
          .post("mail/updatemail", params)
          .then(res2 => {
            console.log(res2);
            if (res2.status) {
              console.log("邮箱 启用/禁用 成功");
              _this.$message.success(this.$t("poolOfMoney_page.opeOk"));  //操作成功
              _this.getMailBoxList();
            } else {
              this.$message.error(
                _this.$t(`poolOfMoney_error.${res2.errorCode}`)
              );
              if (res2.errorCode == "loan_audit_50000031") {
                setTimeout(function() {
                  window.location.reload();
                }, 1500);
              }
            }
          });
      }
      this.delUserDialogVisible = false;
    },

    //新增邮箱
    addUser(){
      this.$refs.addUserFormRef.validate(valid => {
        if (!valid) return;
        let params = {
          name: this.addUserForm.name,
          mail: this.addUserForm.mail,
          markes:this.addUserForm.markes,
        };
        this.axios.post("mail/addmail", params).then(res => {
            console.log(res);
            if (res.status) {
              console.log("新增邮箱成功");
              this.getMailBoxList();
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              );
              if (res.errorCode == "loan_audit_50000031") {
                setTimeout(function() {
                  window.location.reload();
                }, 1500);
              }
            }
          });
        this.addUserDialogVisible = false;
      });
    },

    // 关闭添加用户对话框时清空数据
    addUserDialogClosed() {
      this.$refs.addUserFormRef.resetFields();
    },

  },
}
</script>

<style lang="scss" scoped>
.mail-btn-primary{
  width: 150px;
  height: 38px;
  background: #7996f5;
  border-radius: 2px;
  color: #fff;
}
.mail-btn-default {
  width: 150px;
  height: 38px;
  background: #ffffff;
  border: 1px solid #7996f5;
  border-radius: 2px;
  color: #7996f5;
}
.addMailBoxBtn{
  float: right;
  margin-right: 30px;
}

.emailManagement {
  font-size: 14px;

  &-pagination-box {
    padding: 30px 0;
  }
  &-table {
    width: 100%;
    border: none;
    font-weight: normal;
    color: #606266;
    text-align: left;
    border-collapse: collapse;
    thead {
      height: 50px;
      line-height: 50px;
      color: #828baf;
      background: #f8fafd;
    }
    th {
      padding: 0;
      height: 50px;
      font-weight: normal;
      text-align: left;
    }
    td {
      height: 60px;
      padding: 0;
      //white-space: nowrap;
      overflow: hidden;
      //text-overflow: ellipsis;
      border-bottom: 1px solid #EAEAEA;
      .adminSpan {
        margin: 0 !important;
      }
    }
    span {
      color: #7996f5;
      cursor: pointer;
      margin: auto 10px;
    }
  }
}
.addMailBoxSpan {
  box-sizing: border-box;
  display: inline-block;
  width: 440px;
  height: 70px;
  box-shadow: inset 0 1px 0 0 #eaeaea;
  margin-left: 30px;
  padding-top: 16px;
}
.delUserDialogContent {
  width: 350px;
  height: 40px;
  margin: 0 auto;
  text-align: center;
}
.addMailBoxDlg{
  box-sizing: border-box;
  .el-form {
    height: 168px;
    //background-color: red;
    padding-top: 20px;
    .el-form-item__label {
      padding-right: 30px;
      color: #81899E;
    }
  }
}
</style>
